import { useQuery } from 'react-query';

import { getCurrentSPI as queryFn } from 'api/endPoints/getCurrentSPI';
import { QueryResponse } from 'api/endPoints/getScheduleQualityScore/types';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCurrentSPI = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getCurrentSPI', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId) && Boolean(params.contractId),
    });
};
